import * as angular from 'angular';
import template from './flexInpectConfig.tpl.html';

export default angular.module('aps.controller.flexInspectConfig', [])
  .directive('apsFlexInspectConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/flexInspectConfig.directive.ts